<template>
	<Layout navbarTitle="" :mainFixed="false">
		

		<div class="container">
			<div class="row">
				<div class="col mb-4 p-2">
					
					<Events />

				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import { mapGetters } from "vuex"
import Layout from "@/components/layout/Layout"
import Events from "@/views/event/Events"

export default {
	name: "dashboard",
	components: {
		Layout,
		Events
	},
	computed: {
		...mapGetters(["loggedUser"])
	},
	data() {
		return {
			data: null,
			loading: false
		}
	},
	methods: {
		
	}
}
</script>

<style scoped lang="scss">
h1 {
	font-size: 22px;
	font-weight: 500;
}

.btn-main {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 0.95rem;
	border: solid 1px #f3f3f3;
}
.btn-main:hover {
	background-color: #0f009915;
}
.btn-main .icon {
	flex-grow: 0;
	flex-shrink: 0;
	font-size: 22px;
}
.btn-main .data {
	flex-grow: 1;
	padding: 2px 14px;
	text-align: left;
}
.btn-main .data h3 {
	font-size: 14px;
	font-weight: 600;
}
.btn-main .data p {
	color: #f3f3f3;
	margin: 0px;
}
</style>
